/**
 * Client-side analytics tracking utility
 */

// Generate or retrieve session ID
function getSessionId(): string {
  if (typeof window === "undefined") return ""
  
  let sessionId = sessionStorage.getItem("analytics_session_id")
  if (!sessionId) {
    sessionId = `sess_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`
    sessionStorage.setItem("analytics_session_id", sessionId)
  }
  return sessionId
}

// Get UTM parameters from URL
function getUTMParams(): {
  utmSource?: string
  utmMedium?: string
  utmCampaign?: string
  utmTerm?: string
  utmContent?: string
} {
  if (typeof window === "undefined") return {}
  
  const params = new URLSearchParams(window.location.search)
  return {
    utmSource: params.get("utm_source") || undefined,
    utmMedium: params.get("utm_medium") || undefined,
    utmCampaign: params.get("utm_campaign") || undefined,
    utmTerm: params.get("utm_term") || undefined,
    utmContent: params.get("utm_content") || undefined,
  }
}

// Track page view
export async function trackPageView(pageTitle?: string) {
  if (typeof window === "undefined") return

  try {
    const sessionId = getSessionId()
    const referrer = document.referrer || null
    const utmParams = getUTMParams()

    await fetch("/api/analytics/track", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        sessionId,
        pagePath: window.location.pathname + window.location.search,
        pageTitle: pageTitle || document.title,
        referrer,
        ...utmParams,
        screenWidth: window.screen.width,
        screenHeight: window.screen.height,
        language: navigator.language,
      }),
    })
  } catch (error) {
    // Silently fail - don't break the user experience
    console.error("Analytics tracking failed:", error)
  }
}

// Track conversion event
export async function trackConversion(
  eventType: "signup" | "checkout_started" | "checkout_completed" | "subscription_created" | "license_redeemed",
  metadata?: Record<string, any>
) {
  if (typeof window === "undefined") return

  try {
    const sessionId = getSessionId()
    const referrer = document.referrer || null
    const utmParams = getUTMParams()

    await fetch("/api/analytics/track", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        sessionId,
        pagePath: window.location.pathname + window.location.search,
        pageTitle: document.title,
        referrer,
        ...utmParams,
        eventType,
        metadata,
      }),
    })
  } catch (error) {
    console.error("Analytics conversion tracking failed:", error)
  }
}
